import { useTranslation } from "react-i18next";

import CurrencyCell from "@/components/ui/v1/table/CurrencyCell";
import { TableLinkCell } from "@/components/ui/v1/table/TableCells";
import { CampaignIntegrationMonthType } from "@/types/response/CampaignIntegrationMonthType";
import { TableColumn } from "@/types/table/tableProps";

export const useCampaignIntegrationMonthTableColumns = () => {
  const { t } = useTranslation();

  const campaignIntegrationMonthTableColumns: TableColumn<CampaignIntegrationMonthType>[] =
    [
      {
        accessor: "client.name",
        Cell: (row: CampaignIntegrationMonthType) => (
          <TableLinkCell
            label={row.client.name}
            link={`/clients/${row.clientId2}`}
          />
        ),
        header: t("common.client"),
        width: "25%",
      },
      {
        accessor: "campaign.name",
        Cell: (row: CampaignIntegrationMonthType) => (
          <span>{row.campaignName}</span>
        ),
        header: t("common.campaign"),
        width: "25%",
      },
      {
        accessor: "budget",
        Cell: (row: CampaignIntegrationMonthType) => {
          const showMarginBreakdown = !row.isInvoiced && row.includeMargin;
          return (
            <CurrencyCell
              value={showMarginBreakdown ? row.invoiceableBudget : row.budget}
              secondaryValue={showMarginBreakdown ? row.budget : undefined}
            />
          );
        },
        header: t("common.budget"),
        width: "25%",
      },
      {
        accessor: "spent",
        Cell: (row: CampaignIntegrationMonthType) =>
          row.spent === null ? (
            <span>-</span>
          ) : (
            <CurrencyCell value={row.spent} />
          ),
        header: t("common.invoice"),
        width: "20%",
        sortable: false,
      },
    ];

  return {
    campaignIntegrationMonthTableColumns,
  };
};
